import { Component, Input } from "@angular/core";
import { NumberFormatHelper } from "app/core/helpers/number-format.helper";

@Component({
    selector: "app-tooltip-template-pay-withdraw",
    templateUrl: "./tooltip-template-pay-withdraw.component.html",
    styleUrls: ["./tooltip-template-pay-withdraw.component.scss"],
    standalone: false
})
export class PayWithdrawTooltipTemplate {
  constructor() {}
}
